import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Merges Tailwind classes safely, resolving conflicts via tailwind-merge
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
